function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M511.997,400.144c-170.666,69.189-341.331-69.189-511.997,0c0-96.095,0-192.191,0-288.286 c170.666-69.189,341.331,69.189,511.997,0C511.997,207.952,511.997,304.049,511.997,400.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31AF0E"
    },
    d: "M512,304.051c0,32.034,0,64.057,0,96.092c-170.665,69.189-341.331-69.189-511.997,0 c0-32.034,0-64.057,0-96.092C170.669,234.862,341.335,373.24,512,304.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M512,111.856c0,32.034,0,64.057,0,96.092c-170.665,69.189-341.331-69.189-511.997,0 c0-32.034,0-64.057,0-96.092C170.669,42.668,341.335,181.045,512,111.856z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C7AAA"
    },
    d: "M275.602,250.235h-13.559l9.587-9.587c1.352-1.35,1.352-3.541,0-4.893 c-1.351-1.35-3.54-1.35-4.892,0l-9.587,9.587v-13.558c0-1.911-1.549-3.459-3.459-3.459c-1.911,0-3.459,1.549-3.459,3.459v13.559 l-9.587-9.587c-1.35-1.351-3.541-1.35-4.892,0c-1.351,1.351-1.351,3.541,0,4.893l9.587,9.587h-13.559 c-1.911,0-3.459,1.549-3.459,3.459c0,1.911,1.549,3.459,3.459,3.459h13.558l-9.587,9.587c-1.35,1.35-1.35,3.541,0,4.893 c0.675,0.675,1.561,1.012,2.446,1.012s1.771-0.338,2.446-1.014l9.587-9.587v13.559c0,1.911,1.549,3.459,3.459,3.459 c1.911,0,3.459-1.549,3.459-3.459v-13.558l9.586,9.586c0.676,0.676,1.561,1.014,2.446,1.014s1.77-0.338,2.446-1.012 c1.351-1.352,1.351-3.541,0-4.893l-9.587-9.587h13.561c1.911,0,3.459-1.549,3.459-3.459 C279.061,251.785,277.513,250.235,275.602,250.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C7AAA"
    },
    d: "M253.692,293.058c-21.705,0-39.364-17.658-39.364-39.364s17.658-39.364,39.364-39.364 s39.364,17.658,39.364,39.364S275.397,293.058,253.692,293.058z M253.692,221.249c-17.89,0-32.445,14.555-32.445,32.445 s14.555,32.445,32.445,32.445s32.445-14.555,32.445-32.445S271.582,221.249,253.692,221.249z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.4d07e178ff1246066ee5f6bad7b25eab.svg";
export { ForwardRef as ReactComponent };